import './AdminLoader.css';

function AdminLoader({ label = 'Loading…', size = 'md', inline = false }) {
  return (
    <div
      className={`admin-loader${inline ? ' admin-loader--inline' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <span
        className={`admin-loader__spinner admin-loader__spinner--${size}`}
        aria-hidden="true"
      />
      {label && !inline && <p className="admin-loader__label">{label}</p>}
    </div>
  );
}

export default AdminLoader;
